module.exports = function() {
  return new Worker(__webpack_public_path__ + "e105c38c7ce05659265d.worker.js");
};